export const ORDER_INFO_ROUTE_PATTERN =
  "/orders/:orderId/configure/order-info" as const;

export const PRODUCT_STEP_ROUTE_PATTERN =
  "/orders/:orderId/configure/products/:productId/:step?" as const;

export const ORDER_SUMMARY_ROUTE_PATTERN =
  "/orders/:orderId/configure/summary" as const;

export const ADD_PRODUCT_ROUTE_PATTERN =
  "/orders/:orderId/configure/products/add" as const;
